var map = {
	"./icon-apibind-active.png": 6302,
	"./icon-dashboard-active.png": 3861,
	"./icon-doc-active.png": 2419,
	"./icon-internet-active.png": 2850,
	"./icon-matrix-active.png": 7418,
	"./icon-task-active.png": 662,
	"./icon-user-active.png": 1448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4426;